export default __webpack_public_path__ + "static/media/client2.f7fa859e.jpeg";